import React, { Fragment, useState, useEffect, useRef } from 'react';
import MainTitle from '../../components/MainTitle';
import Chart from 'react-google-charts';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { isMobile } from 'react-device-detect';
import Moment from 'moment';
import 'moment/locale/es';
import { extendMoment } from 'moment-range';
import { connect } from 'react-redux';
import Rating from '@material-ui/lab/Rating';
import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery, Grid } from '@material-ui/core';
import FilterDropdown from '../Modal/FilterDropdown';
import Card from '../Cards/';
import Rewards from '../Rewards';
import ChartMessages from './containers/ChartMessages';
import ChartViews from './containers/ChartViews';
import ChartOpinions from './containers/ChartOpinions';

import {
  getWeekRanges,
  countBy,
  getDate,
  getChartData,
} from './containers/DatesAnalytics';

import './Analytics.scss';
import ChartContact from './containers/ChartContact';

const star = '/img/icons/star-green.svg';
const starGray = '/img/icons/star-gray.svg';
const useStyles = makeStyles((theme) => ({
  rating: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 55,
  },
  starIcons: {
    fontSize: '2.5rem',
    color: '#ffc200',
  },
  emptyStar: {
    color: '#c1c1c1',
  },
  freeGrid: {
    margin: '0 0 104px',
  }
}));

const moment = extendMoment(Moment);

let startMonth0 = moment().month(0).startOf('month');
let endMonth0 = moment().month(0).endOf('month');

const Analytics = ({ authClient }) => {
  const mdScreen = useMediaQuery('(max-width:959px)');
  const tabletSize = useMediaQuery('(max-width:768px)');
  const small = useMediaQuery('(max-width:425px)');
  const classes = useStyles();

  const moment = extendMoment(Moment);
  const weekRanges = getWeekRanges(4);

  const analyticsViewProfile = authClient.analyticsViewProfile;
  const analyticsOpinion = authClient.analyticsOpinion;
  const analyticsMessage = authClient.analyticsMessage;

  const analyticsWeb = authClient.analyticsWeb;
  const analyticsWhatsapp = authClient.analyticsWhatsapp;
  const analyticsPhone = authClient.analyticsPhone;
  const analyticsMail = authClient.analyticsMail;
  const analyticsMedios = authClient.analyticsMedios;

  /* const filterMonthly = (dataToFilter) => {
      //console.log('dataToFilter', dataToFilter)
    const dataFiltered = [];
    for (let i = 0; i < monthWeeks.length - 1; i++) {
      if (i == monthWeeks.length - 2) {
        dataFiltered.push(
          dataToFilter &&
            dataToFilter.filter((item) =>
              moment
                .unix(item.createdAt.seconds)
                .local()
                .isBetween(moment(monthWeeks[i]), moment(endMonth))
            ).length
        );
      } else {
        dataFiltered.push(
          dataToFilter &&
            dataToFilter.filter((item) =>
              moment
                .unix(item.createdAt.seconds)
                .local()
                .isBetween(
                  moment(monthWeeks[i]),
                  moment(monthWeeks[i]).add(6, 'days')
                )
            ).length
        );
      }
    }
    return dataFiltered;
  }; */

  //const dataChartOpinions = filterMonthly(analyticsOpinion);

  //console.log('dataChartOpinions', dataChartOpinions)

  /* Get data visits */

  return (
    <Fragment>
      <div className={'analytics'}>
        <div style={{ padding: tabletSize ? '0 24px' : null }}>
          <MainTitle
            title='Analytics'
            subtitle='Este apartado ofrece informes sobre la actividad, interacción, número de visitas y el comportamiento que la audiencia ha tenido con tu perfil.'
          />
        </div>
        <div style={{ marginTop: 24 }}>
          {authClient &&
            authClient.membership &&
            authClient.membership.type !== 'Free' && (
              <>
                <ChartMessages analyticsMessage={analyticsMessage} />

                <Grid container spacing={mdScreen || isMobile ? 0 : 2}>
                  <Grid item xs={12} md={6}>
                    <div
                      style={{ marginBottom: mdScreen ? 24 : 0, height: 240 }}
                    >
                      <Card
                        title="Calificación"
                        subtitle1="Hasta el día de hoy"
                        subtitle2={`${
                          authClient.analytics.opinion.counts || 0
                        } valoraciones`}
                      >
                        <div
                          className={`grade-stars${
                            isMobile && small ? '-mobile' : ''
                          }`}
                        >
                          <span
                            style={{
                              fontSize: 54,
                              fontWeight: 'bold',
                              color: '#013957',
                              marginRight: isMobile && small ? 16 : 24,
                            }}
                          >
                            {Number(authClient.analytics.opinion.qualification)}
                          </span>
                          <div style={{ display: 'flex', flexShrink: '1' }}>
                            {authClient && authClient ? (
                              <Rating
                                value={
                                  authClient.analytics.opinion.qualification
                                }
                                precision={0.25}
                                classes={{
                                  root: classes.starIcons,
                                  iconEmpty: classes.emptyStar,
                                  icon: classes.cardIcon,
                                }}
                                readOnly
                              />
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      </Card>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div style={{ height: isMobile ? 'auto' : 240 }}>
                      <Card
                        title="Logros obtenidos"
                        //link="Ver logros"
                        link={
                          <HashLink
                            smooth
                            to="/dashboard/perfil/#progress"
                            style={{ color: 'inherit', textDecoration: 'none' }}
                          >
                            Ver logros
                          </HashLink>
                        }
                        linkPosition="top"
                      >
                        <Rewards />
                      </Card>
                    </div>
                  </Grid>
                </Grid>
              </>
            )}

          <ChartViews
            analyticsViewProfile={analyticsViewProfile && analyticsViewProfile}
          />
          
          {authClient &&
          authClient.membership &&
          authClient.membership.type === 'Free' ?
            <Grid item xs={12} md={6} className={classes.freeGrid}>
              <Card
                title="Logros obtenidos"
                link={
                  <HashLink
                    smooth
                    to="/dashboard/perfil/#progress"
                    style={{ color: 'inherit', textDecoration: 'none' }}
                  >
                    Ver logros
                  </HashLink>
                }
                linkPosition="top"
              >
                <Rewards />
              </Card>
            </Grid> : null
          }

          {authClient &&
            authClient.membership &&
            authClient.membership.type !== 'Free' && (
              <>
                <Grid container spacing={mdScreen || isMobile ? 0 : 2}>
                  <Grid item xs={12} md={6} lg={6}>
                    <ChartOpinions
                      analyticsOpinion={analyticsOpinion && analyticsOpinion}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <ChartContact
                      analyticsWeb={analyticsWeb}
                      analyticsPhone={analyticsPhone}
                      analyticsMail={analyticsMail}
                      analyticsWhatsapp={analyticsWhatsapp}
                      analyticsMedios={analyticsMedios}
                    />
                  </Grid>
                </Grid>
              </>
            )}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  authClient: state.authClient,
});

export default connect(mapStateToProps)(Analytics);
